import { Box, Button, Stack, Typography } from "@mui/material";
import { routes } from "../../routes/index";
import RouteItem from "../../routes/index";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

type Props = {};
interface InputProps {
  currentPath: string | null;
  parentPath: string;
  setCurrentPath: Function;
  setParentPath: Function;
}
const SideBar = ({
  currentPath,
  parentPath,
  setCurrentPath,
  setParentPath,
}: InputProps) => {
  const [sideBarRoutes, setSideBarRoutes] = useState<Array<RouteItem>>();

  useEffect(() => {
    for (let i of routes) {
      if (i?.path === parentPath && i?.subRoutes) {
        setSideBarRoutes(i?.subRoutes);
      }
    }
  }, []);
  const navigate = useNavigate();

  return (
    <Stack direction="column" spacing={2} alignItems={"flex-start"}>
      {routes.map((menu: RouteItem, i: number) => (
        <>
          {menu?.subRoutes && menu.path === parentPath && (
            <>
              {" "}
              <Typography
                variant="body1"
                sx={{ display: { xs: "none", md: "block" } }}
              >
                QUICK LINKS
              </Typography>
            </>
          )}
        </>
      ))}

      <Stack
        height="100%"
        minWidth={"fit-content"}
        direction={{ xs: "row", md: "column" }}
        alignItems={"center"}
        justifyContent={"center"}
        width={{ xs: "100vw", md: "fit-content" }}
        flexWrap={"nowrap"}
        sx={{
          overflow: "scroll",
          border: "1px solid",
          borderColor: "background.secondary",
        }}
      >
        {routes.map((menu: RouteItem, i: number) => (
          <>
            {menu.subRoutes &&
              menu.path === parentPath &&
              menu.subRoutes.map((subMenu: RouteItem, i: number) => (
                <Button
                  key={menu.key}
                  sx={{
                    display: "flex",
                    flexWrap: "nowrap",
                    textWrap: "nowrap",
                    width: { xs: "fit-content", md: "100%" },
                    border: "1px solid",
                    borderColor: "black",
                    borderRadius: 0,
                    height: "100%",
                    padding: 0,
                    px: 1,
                    textTransform: "none",
                    justifyContent: "flex-start",
                    bgcolor:
                      currentPath === subMenu.path
                        ? "background.secondary"
                        : "",
                    ":hover": {
                      bgcolor: "background.secondary",
                      color: "text.secondary",
                    },
                    color: currentPath === subMenu.path ? "text.secondary" : "",
                  }}
                  onClick={() => {
                    setCurrentPath(subMenu.path);
                    setParentPath(menu.path);
                    if (subMenu.subRoutes) {
                      navigate(menu.path + "/" + subMenu.path, {
                        state: { menuItem: subMenu.subRoutes, activeTab: 0 },
                      });
                    } else {
                      navigate(menu.path + "/" + subMenu.path);
                    }
                  }}
                >
                  {subMenu.title}
                </Button>
              ))}
          </>
        ))}
      </Stack>
    </Stack>
  );
};

export default SideBar;
